// frontend/src/pages/Reinsurance/components/InvestorManagement/index.js

import React from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';
import styles from './InvestorManagement.module.css';

const InvestorManagement = () => {
  const { t } = useLanguage();
  
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t('investor_management')}</h1>
      <p>{t('coming_soon')}</p>
    </div>
  );
};

export default InvestorManagement;